<template>
  <div style="margin: 0 10px">
    <draggable
      v-model="orderMaps"
      group="maps"
      @start="dragStart"
      @end="dragStop"
      @change="sortChange"
      item-key="id"
    >
      <template #item="{ element }">
        <Component
          :is="element.mapType"
          :map="element"
          :index="getMapIndex(element)"
        />
      </template>
    </draggable>
    <el-empty
      :description="$t('DisplayedMap.nomaps')"
      v-show="empty"
      :image-size="80"
    />
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import MapItem from '@/components/maps/MapItem';
import ImportMapItem from '@/components/maps/ImportMapItem';
export default {
  components: {
    MapItem,
    ImportMapItem,
    draggable,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    orderMaps: {
      get() {
        return this.$store.state.maps.orderList;
      },
      set(newList) {
        this.$store.dispatch('maps/setOrderList', newList);
      },
    },
    empty() {
      return this.orderMaps.length == 0;
    },
  },
  methods: {
    setDragCursor(value) {
      const html = document.getElementsByTagName('html').item(0);
      html.classList.toggle('grabbing', value);
    },
    dragStart() {
      this.setDragCursor(true);
    },
    dragStop() {
      this.setDragCursor(false);
    },
    sortChange(evt) {
      const { moved } = evt;
      if (moved) {
        this.$EventBus.emit('globalmoveLayer', {
          from: moved.oldIndex,
          to: moved.newIndex,
        });
      }
    },
    getMapIndex(map) {
      const idx = this.orderMaps.findIndex((m) => m.id === map.id);
      return idx;
    },
  },
};
</script>
